/* global femcare, Swiper */

/**
 * Banner module for initializing the swiper slider and repositioning the product rating.
 */
femcare.banner = {
    bannerElement: document.querySelector('.banner'),
    delayedAnimationBanner: document.querySelector('.banner--delayed'),

    /**
     * Initializes the banner slider and other functionalities if the banner exists.
     */
    init() {
        if (this.bannerElement) {
            this.initSlider();
            this.repositionPowerReviewRating();

            if (this.delayedAnimationBanner) {
                this.delayedAnimation();
            }
        }
    },

    /**
     * Initializes the Swiper slider with autoplay functionality.
     */
    initSlider() {
        new Swiper(this.bannerElement, {
            slidesPerView: 1,
            spaceBetween: 50,
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
            },
        });
    },

    /**
     * Removes 'banner--delayed' class after 5 seconds if banner contains it.
     */
    delayedAnimation() {
        setTimeout(() => {
            this.delayedAnimationBanner.classList.remove('banner--delayed');
        }, 5000);
    },

    // TODO: Review why this code is in this file when refactoring PWR - should be removed!!
    repositionPowerReviewRating() {
        const productRatingElement = document.querySelector('.product-main__rating');
        if (productRatingElement) {
            productRatingElement.style.top = '135px';
        }
    }
};
